import { WindowProxy } from '@sm360/widget-commons-core-services';
import { cloneDeep, merge } from 'lodash';

class AdobeService {
    /**
     * Verify if digitaldata is configured in the website
     * @returns {boolean} is available or not
     */
    isDigitalDataAvailable() {
        return !!WindowProxy.get().digitaldata;
    }

    isTrackingAvailable() {
        return typeof WindowProxy.get()._satellite?.track === 'function';
    }

    eventTrigger(adobeTag, variantName) {
        // store a copy of the original digitaldata before changing its params
        const originalDigitaldata = cloneDeep(WindowProxy.get().digitaldata);
        if (this.isDigitalDataAvailable() && this.isTrackingAvailable()) {
            WindowProxy.get().digitaldata = merge(cloneDeep(originalDigitaldata), adobeTag);
            // track the event
            WindowProxy.get()._satellite.track(variantName);

            // set the original digitaldata back after tracking
            setTimeout(() => {
                WindowProxy.get().digitaldata = originalDigitaldata;
            }, 1000);
        }

        return null;
    }
}

export default new AdobeService();
